// removed by extract-text-webpack-plugin
module.exports = {"summaryCell":"CBDView__summaryCell___1RRu3","mainContentWrapper":"CBDView__mainContentWrapper___3F5Mf","referenceCardWrapper":"CBDView__referenceCardWrapper___Dww5w","referenceCardRow":"CBDView__referenceCardRow___MbdNK","summarySection":"CBDView__summarySection___KlgEY","topRow":"CBDView__topRow___3kSGX","leftContainer":"CBDView__leftContainer___2T331","summaryRight":"CBDView__summaryRight____ZYRZ","summaryTables":"CBDView__summaryTables___1EJ2G","stackedBarChartWrapper":"CBDView__stackedBarChartWrapper___rsdrP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MainContent/CBDView.less
// module id = 456
// module chunks = 0